/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_NoteInputs */

const cs_activity_note = /** @type {(inputs: Activity_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámka`)
};

const en_activity_note = /** @type {(inputs: Activity_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {Activity_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const activity_note = /** @type {((inputs?: Activity_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activity_note(inputs)
	return cs_activity_note(inputs)
});